import React, {useEffect, useState} from "react";
import "./PackManDetail.scss";
import {PackManHederBack} from "../PackManHederBack/PackManHederBack";
import {useHistory, useParams} from "react-router-dom";
import { Drawer, message, Popconfirm } from 'antd';
import {SaveOutlined} from '@ant-design/icons';


import {
    bulkUpdateOrderItmesPickedQuantityWithOrderPicker_api,
    finalizeOrderWithOrderPicker_api,
    orderPickerOrderChangeQuantity_api,
    orderPickerOrderDetail_api,
    orderPickerUpdateOrderRowQuantity_api,
    orderPickerUpdatePickedQuantity_api,
    picking_done_api, StoreOnlineSearch,
    updateOrderWithOrderPicker_api
} from "../PackManService";
import {convertStatusCode, ConvertToJalaliSplitedString} from "../../../Services";
import Rodal from "rodal";
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import toaster from "toasted-notes";
import {SearchCard} from "../SearchCard/SearchCard";
import {AddCard} from "../AddCard/AddCard";

let finalOrder = {}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function PackManDetail() {

    //hooks
    const history = useHistory()
    const {id} = useParams()

    //states
    const [order,set_order] = useState(null)
    const [readyLadda,set_readyLadda] = useState(false)
    const [doneLadda,set_doneLadda] = useState(false)
    const [finalModal,set_finalModal] = useState(false)
    const [scanModal,set_scanModal] = useState(false)
    const [cashDeskCode,set_cashDeskCode] = useState("")
    const [ data, setData ] = React.useState('Not Found');

    useEffect(()=>{
        orderPickerOrderDetail_func()
    },[])





    //funcs

    // finalize order with order picker
    const finalization = async () =>{

            let obj = {
                // "client_invoice_id": cashDeskCode
            }
            try{
                const response = await finalizeOrderWithOrderPicker_api(id,obj)
                set_finalModal(false)
                set_order({...order, status: 13})
                history.goBack()
            }catch (e) {
                console.log(e);
                set_finalModal(false)
            }


    }


    const checkPickedComplete = (data)=>{
        let preData = data.filter(i=> !i.is_canceled)
        let filter = preData.filter(i=>i.quantity!==i.picked_quantity)
        console.log("filter : ", filter)
        return filter.length === 0
    }


    const sendPickedOrder = ()=>{
        console.log("new order : ",order)
        console.log("final",finalOrder)

    }

    const readyToBox = async () =>{
        set_readyLadda(true)
        let obj = {
            status: 10
        }
        try{
            const res = await orderPickerOrderDetail_api(id);
            set_order(res.data);
            if(checkPickedComplete(res.data.items)){
                const response = await picking_done_api(id,obj)
                set_readyLadda(false)
                if(response.data.pay_status === 1){
                    history.goBack()
                }else {
                    set_order({...res.data, status: 10})
                }
            }else {
                set_readyLadda(false)
                toaster.notify(({ onClose }) => (<Error   message={"سبد جمع آوری شما ناقص است"}/>),{duration: 2000})
            }
        }catch (e) {
            set_readyLadda(false)
            toaster.notify(({ onClose }) => (<Error   message={"سبد جمع آوری شما ناقص است"}/>),{duration: 2000})
            console.log(e)
        }

    }

    const orderPickerOrderDetail_func = async () =>{
        try{
            const response = await orderPickerOrderDetail_api(id);
            set_order(response.data);
            finalOrder= response.data
        }catch (e) {
            console.log(e)
        }
    }

    //components

    const ItemRow = ({rec,deleteRow,changeQuantity}) =>{

        const [pick,set_pick] = useState(0)
        const [quantity,set_quantity] = useState("")
        const [originalQuantity,set_originalQuantity] = useState("")
        const [loading,set_loading] = useState(false)


        useEffect(()=>{
            set_quantity(rec.quantity)
            set_originalQuantity(rec.quantity)
            set_pick(rec.picked_quantity)
        },[])

        const add = async ()=>{
            if(pick+1>quantity){return}
            if(!loading){
                set_loading(true)

                let obj = {
                    picked_quantity :pick+1
                }
                try{
                    const response = await orderPickerUpdatePickedQuantity_api(id,rec.uid,obj)
                    set_loading(false)
                    set_pick(pick+1)
                }catch (e) {
                    console.log(e)
                    set_loading(false)
                }
            }
        }

        const remove = async ()=>{
            if(pick===0){return ;}
            if(!loading){
                set_loading(true)
                let obj = {
                    picked_quantity :pick-1
                }
                try{
                    const response = await orderPickerUpdatePickedQuantity_api(id,rec.uid,obj)
                    set_loading(false)
                    set_pick(pick-1)
                }catch (e) {
                    set_loading(false)
                    console.log(e)
                }
            }
        }

        const deleteProduct = async () =>{
            // deleteRow(rec.product.uid)
            let obj = {
                "product_id": rec.product.uid,
                "quantity": 0
            }
            try{
                const response = await orderPickerOrderChangeQuantity_api(id,obj)
                orderPickerOrderDetail_func()
            }catch (e) {
                console.log(e)
                orderPickerOrderDetail_func()
            }
        }




        const [saveSpin,set_saveSpin] = useState(false)
        const confirm = async () => {
            console.log(rec)
            set_saveSpin(true)
            let obj = {
                "product_id": rec.product.uid,
                "quantity": parseInt(quantity)
            }
            try{
                const resp = await orderPickerOrderChangeQuantity_api(id,obj)
                orderPickerOrderDetail_func()
                message.success('تغییر انجام شد');
                set_saveSpin(false)
                set_originalQuantity(quantity)
            }catch (e){
                message.error('متاسفانه تغییر انجام نشد');
                set_saveSpin(false)
                set_quantity(originalQuantity)
                set_saveVisible(false)
                console.log(e)
            }
        };

        const [saveVisible,set_saveVisible] = useState(false)

        const handleChangeInput = (e)=>{
            const value = e.target.value
            set_quantity(value)
            // changeQuantity(rec.product.uid,value)
            console.log(e.target.value,originalQuantity,e.target.value!==originalQuantity.toString())
            if(e.target.value!==originalQuantity.toString() && e.target.value!=="")
                set_saveVisible(true)
            else
            set_saveVisible(false)
        }

        return(
            <tr className="ribbon yellow-ribbon">
                <td>
                    {rec  && rec.product?<span className="name">{ rec.product.name.length<20?rec.product.name:rec.product.name.substr(0,20)+"..."}</span>:null}
                </td>
                <td>
                    <div className="inc-dec-sec">
                        <div className="inc-dec-btn" onClick={add}>
                            <img src="/svg/incr.svg" alt=""/>
                        </div>

                        {loading?<i className="fa fa-spinner fa-spin"></i>:
                            <div>
                                <span>{pick}</span>
                                {/*<span>/</span>*/}
                                {/*<span>{quantity}</span>*/}
                            </div>
                        }
                        <div className="inc-dec-btn" onClick={remove}>
                            <img src="/svg/decr.svg" alt=""/>
                        </div>
                    </div>
                </td>
                <td>
                    <div className="packman-detail-input-wrapper">
                        <div className="packman-detail-input-body" >
                            {saveVisible?<Popconfirm placement="topLeft" title={"آیا از تغییر تعداد مطمئن هستید ؟"} onConfirm={confirm} okText="بله" cancelText="انصراف">
                                <span className="packman-detail-save-btn"><SaveOutlined /></span>
                            </Popconfirm>:null}
                            {saveSpin?<i className="fa fa-spinner fa-spin"></i>:<input
                                value={quantity}
                                pattern="\d*" maxlength="4"
                                onChange={handleChangeInput}
                                className="packman-detail-input" type="text" name="" id=""/>}

                        </div>
                    </div>
                </td>
                <td>
                    <div className="actoins-icon" onClick={deleteProduct}>
                        {/*<img src="/svg/clarity_details-line.svg" alt=""/>*/}
                        <img src="/svg/trash.svg" alt=""/>
                    </div>
                </td>
            </tr>
        )
    }

    const clientCall = (phone)=>{
        if(phone){
            document.location.href="tel:"+phone;
        }
    }



    const changeQuantity = (id,q)=>{
        console.log(id,q)
        let clone = {...finalOrder}
        let find = finalOrder.items.find(o=>o.product.uid===id)
        find['quantity'] = parseInt(q)
        clone['items'] =  finalOrder.items.map(o=>{
            return o.product.uid===id? find:o
        })
        finalOrder = clone
    }

    const deleteRow = (id)=>{
        let clone = {...order}
        clone['items'] =  order.items.filter(o=>o.product.uid!==id)
        set_order(clone)
        finalOrder= clone
    }

    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    const [addList,set_addList] = useState([])
    const [merchant, set_merchant] = useState(null)
    const [searchMode, set_searchMode] = useState(false)
    const [results, set_results] = useState([])
    const [search, set_search] = useState([])
    const [submitLadda, set_submitLadda] = useState(false)


    const doSearch = async (value) => {
        window.hh = 1;
        set_search(value)
        console.log("word : ", value);
        if (value.length > 2) {
            set_searchMode(true);
            try {
                let response = await StoreOnlineSearch( value, 1);
                console.log("Searched : ", response);
                let tt= response.data.results.map(r=>{
                    return {...r,product:r,picked_quantity:0,}
                })
                set_results(tt);
                const elm = document.getElementById("searchList");
                elm.scrollTo({left: 0, top: 0});
            } catch (e) {
                console.log(e);
            }
        }

        if (value.length < 1) {
            set_searchMode(false);
            set_results([])
        }
    }


    const selectItem = (item)=>{
        set_searchMode(false)
        set_results([])
        set_addList(list=>[...list,item])
    }


    const deleteFromList = (item)=>{
        if(item.quantity-1===0){
            set_addList(addList.filter(pro=>pro.uid!==item.uid))
            return;
        }
        set_addList(
            addList.map(pro =>
                pro.uid === item.uid ? {...pro, quantity : item.quantity-1} : pro
            ))
    }

    const addToList = (item)=>{
        set_addList(
            addList.map(pro =>
                pro.uid === item.uid ? {...pro, quantity : item.quantity+1} : pro
            ))
    }

    const addProductsToMainList = (p)=>{
        if(p?.length > 0){
            set_order({...order,items:[...order.items,...p]})
            finalOrder= {...order,items:[...order.items,...p]}
        }
        set_addList([])
        setOpen(false)
    }


    return(
        <div className="packMan-detail-container">

            <Drawer width={300} placement="right" closable={false}   onClose={onClose} open={open}>

                <div className="packMan-drawer-header">
                    <span className="packMan-drawer-header-btn" onClick={e=>{
                        addProductsToMainList(addList)
                    }}>اضافه کردن</span>
                    <span className="packMan-drawer-header-title">اضافه کردن محصول</span>
                </div>

                <div className="packMan-add-body-new">

                    {/*factor row*/}
                    {/*<div className="add-factor-row">*/}
                    {/*    <div className="add-factor-item">*/}
                    {/*        <span>{id}</span>*/}
                    {/*        <img src="/svg/clarity_details-line.svg" alt=""/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}


                    <div className="add-search-row">
                        <input type="text" name="" id=""
                               value={search}
                               onChange={(e) => {
                                   doSearch(e.target.value)
                               }}
                               placeholder="جستجوی سفارشات"/>
                        <img src="/svg/magni.svg" alt=""/>
                    </div>

                    {searchMode?<div className="packMan-searchList-new">
                        <div className="packMan-searchList-card">
                            {results.map(pro=>{
                                return(
                                    <SearchCard item={pro} select={selectItem}/>
                                )
                            })}
                        </div>
                    </div>:null}

                    <div className="packMan-add-list">
                        {addList.map(item=>{
                            return(
                                <AddCard item={item} remove={deleteFromList} add={addToList}/>
                            )
                        })}
                    </div>
                </div>

            </Drawer>

            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                animation={"zoom"} visible={finalModal} onClose={()=>set_finalModal(false)}>

               <div className="finalModal">
                   <div className="finalModal-text">
                       <span>پایان عملیات صندوق</span>
                       {/*<span className="order-code">54534</span>*/}
                       {/*<span>وارد نمایید</span>*/}
                   </div>


                   {/*<input*/}
                   {/*    value={cashDeskCode}*/}
                   {/*    onChange={(e)=>{*/}
                   {/*        set_cashDeskCode(e.target.value)*/}
                   {/*    }}*/}
                   {/*    type="text" name="" id="" placeholder="کد صندوق"/>*/}

                   <div className="finalModal-btn" onClick={()=>{
                       finalization()
                   }}>
                       <span>تایید</span>
                   </div>
               </div>

            </Rodal>
            <Rodal customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                   animation={"zoom"} visible={scanModal} onClose={()=>set_scanModal(false)}>
               <div>
                   <BarcodeScannerComponent
                       width={'100%'}
                       height={300}
                       onUpdate={(err, result) => {
                           if (result) setData(result.text)
                           else setData('Not Found')
                       }}
                   />
                   <p>{data}</p>
               </div>
            </Rodal>
            <PackManHederBack title="سفارش"/>


            {order?<div className="packMan-detail-body">

                {/*date row*/}
                <div className="detail-date-row">
                    <span style={{direction:'rtl'}}>{ConvertToJalaliSplitedString(order.created)}</span>
                    <span style={{direction:'rtl'}}>{order.user.first_name+" "+order.user.last_name}</span>
                </div>

                {/*factor row*/}
                <div className="detail-factor-row">
                    <div className="detail-factor-item">
                        <span>{order.uid}</span>
                        <img src="/svg/clarity_details-line.svg" alt=""/>
                    </div>
                </div>

                <div className="actions_btn_row">

                    <div className="actions_btn_item" onClick={()=>{
                        if(order && order.user && order.user.phone){
                            clientCall(order.user.phone)
                        }
                    }}>
                        <img src="/svg/carbon_phone.svg" alt=""/>
                        <span>تماس با مشتری</span>
                    </div>

                    {/*<div className="actions_btn_item">*/}
                    {/*    <img src="/svg/mdi_qrcode-scan.svg" alt=""/>*/}
                    {/*    <span>اسکن</span>*/}
                    {/*</div>*/}

                    <div className="actions_btn_item" onClick={()=>{
                        history.push("/pack-man/"+id+"/add")
                        // showDrawer()
                    }}>
                        <img src="/svg/bi_bag-plus.svg" alt=""/>
                        <span>افزودن محصول</span>
                    </div>
                </div>

                <div className="table-row">
                    <table className="table">
                        <tr>
                            <th className="center">نام کالا</th>
                            <th className="center">برداشته شده</th>
                            <th className="center">تعداد</th>
                            <th className="center"></th>
                        </tr>
                        <tbody>
                        {order && order.items && order.items.map(rec=>{
                            return(
                                <>
                                    {!rec.is_canceled?<ItemRow rec={rec} changeQuantity={changeQuantity} deleteRow={deleteRow}/>:null}
                                </>
                            )
                        })}
                        {/*<tr className="ribbon green-ribbon">*/}
                        {/*    <td>*/}
                        {/*        <span className="name">نوشابه انرژی زا ام اف پی</span>*/}
                        {/*    </td>*/}
                        {/*    <td>*/}
                        {/*        <div className="inc-dec-sec">*/}
                        {/*            <img src="/svg/incr.svg" alt=""/>*/}
                        {/*            <span>2/3</span>*/}
                        {/*            <img src="/svg/decr.svg" alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </td>*/}
                        {/*    <td>*/}
                        {/*        <div className="actoins-icon">*/}
                        {/*            <img src="/svg/clarity_details-line.svg" alt=""/>*/}
                        {/*            <img src="/svg/trash.svg" alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        {/*<tr className="ribbon red-ribbon">*/}
                        {/*    <td>*/}
                        {/*        <span className="name">نوشابه انرژی زا ام اف پی</span>*/}
                        {/*    </td>*/}
                        {/*    <td>*/}
                        {/*        <div className="inc-dec-sec">*/}
                        {/*            <img src="/svg/incr.svg" alt=""/>*/}
                        {/*            <span>2/3</span>*/}
                        {/*            <img src="/svg/decr.svg" alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </td>*/}
                        {/*    <td>*/}
                        {/*        <div className="actoins-icon">*/}
                        {/*            <img src="/svg/clarity_details-line.svg" alt=""/>*/}
                        {/*            <img src="/svg/trash.svg" alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        {/*<tr className="ribbon yellow-ribbon">*/}
                        {/*    <td>*/}
                        {/*        <span className="name">نوشابه انرژی زا ام اف پی</span>*/}
                        {/*    </td>*/}
                        {/*    <td>*/}
                        {/*        <div className="inc-dec-sec">*/}
                        {/*            <img src="/svg/incr.svg" alt=""/>*/}
                        {/*            <span>2/3</span>*/}
                        {/*            <img src="/svg/decr.svg" alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </td>*/}
                        {/*    <td>*/}
                        {/*        <div className="actoins-icon">*/}
                        {/*            <img src="/svg/clarity_details-line.svg" alt=""/>*/}
                        {/*            <img src="/svg/trash.svg" alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        </tbody>
                    </table>
                </div>

                <div className="detail-float-row">
                    <div className="detail-float-btns">

                        {order && order.status !== 13 && order.status !== 9 && order.status !== 3?
                        <span style={{margin:4}} className="completed-order" onClick={()=>{
                            set_finalModal(true)
                        }}>
                            <span>تکمیل عملیات صندوق</span>
                            {doneLadda?<i className="fa fa-spinner fa-spin"></i>:null}
                        </span>:null
                        }


                        {order.status !== 10 && order.status !== 13?
                            <span className="ready-to-scan" onClick={()=>{
                            readyToBox()
                            // sendPickedOrder()
                        }}>
                              <span style={{margin:4}}>تکمیل جمع آوری</span>
                            {readyLadda?<i className="fa fa-spinner fa-spin"></i>:null}
                        </span>
                            :null}
                    </div>
                </div>

            </div>:null}


        </div>
    )
}

export {PackManDetail}
